import React, { useState } from "react";
import { t } from "react-multi-lang";
import {
  Checkbox,
  SelectField,
} from "../FormElements/FormElements";
import Modal from "../Modal/Modal";

import { years } from "../../services/hoc/helpers";
import { ClassesMenu } from "../PredefinedMenus/PredefinedMenus";

export default (props: {
  open: boolean;
  toggle(): any;
  link: string;
  showTo?: boolean;
}) => {
  const [classType, setClassType] = useState<any>();
  const [limits, setLimits] = useState<any>(false);
  const [year, setYear] = useState<number>();
  const [quarter, setQuarter] = useState<"q1" | "q2" | "q3" | "q4">();
  const [eYear, setEYear] = useState<number>();
  const [eQuarter, setEQuarter] = useState<"q1" | "q2" | "q3" | "q4">();

  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const getLink = () => {
    if (year && quarter && (!props.showTo || (eYear && eQuarter))) {
      let url = `${props.link}?quarter1=${quarter}&year1=${year}&quarter2=${eQuarter}&year2=${eYear}`;

      if (!props.link.includes("disclosure")) {
        url += `&class_type=${classType?.value || ""}&limits=${
          limits ? "yes" : "no"
        }`;
      }
      if (props.link.includes("disclosure")) {
        url += `&limits=no`;
      }

      return url;
    }
    return "#";
  };

  const downloadReport = async () => {
    const url = getLink();
    if (url === "#") return;

    setLoading(true);
    setProgress(0);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("خطأ أثناء توليد التقرير");

      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;

      const reader = response.body?.getReader();
      if (!reader) throw new Error("خطأ في قراءة الملف");

      const chunks: Uint8Array[] = [];
      let received = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (value) {
          chunks.push(value);
          received += value.length;
          if (total) setProgress(Math.round((received / total) * 100));
        }
      }

      const blob = new Blob(chunks, { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const fileURL = URL.createObjectURL(blob);

      const disposition = response.headers.get("Content-Disposition");
      let filename = "report.xlsx";
      if (disposition && disposition.includes("filename=")) {
        filename = disposition.split("filename=")[1].replace(/"/g, "");
      }

      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (err) {
      alert("حدث خطأ أثناء معالجة التقرير");
      console.error(err);
    }

    setLoading(false);
    setProgress(0);
  };

  return (
    <Modal open={props.open} toggle={props.toggle}>
      <div style={{ minWidth: 500, textAlign: "left" }}>
        <h2>Report Configurations</h2>
        <hr
          style={{
            border: "none",
            borderTop: "1px solid #DDD",
            marginBottom: 30,
          }}
        />
        <form action="">
          {!props.link.split("/").includes("disclosure") && (
            <div className="filter">
              <ClassesMenu
                isClearable
                value={classType}
                onChange={(selected: any) => {
                  setClassType(selected);
                }}
                placeholder="Class Type"
              />
              <Checkbox
                label="Unused Limits"
                style={{ margin: "20px 0" }}
                checked={limits}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setLimits(e.target.checked)
                }
              />
            </div>
          )}

          {props.showTo && <div className="sep text-center">FROM</div>}
          <div className="config">
            <SelectField
              defaultValue={year ? { label: year, value: year } : undefined}
              onChange={(selected: { value: number }) =>
                setYear(selected?.value)
              }
              placeholder={t("year")}
              options={years}
            />
          </div>
          <div className="config">
            <SelectField
              defaultValue={
                quarter
                  ? { label: quarter?.toUpperCase(), value: quarter }
                  : undefined
              }
              onChange={(selected: { value: "q1" | "q2" | "q3" | "q4" }) =>
                setQuarter(selected?.value)
              }
              placeholder={t("quarter")}
              options={[
                { label: "Q1", value: "q1" },
                { label: "Q2", value: "q2" },
                { label: "Q3", value: "q3" },
                { label: "Q4", value: "q4" },
              ]}
            />
          </div>
          {props.showTo && (
            <>
              <div className="sep text-center">TO</div>
              <div className="config">
                <SelectField
                  defaultValue={
                    eYear ? { label: eYear, value: eYear } : undefined
                  }
                  onChange={(selected: { value: number }) =>
                    setEYear(selected?.value)
                  }
                  placeholder={t("year")}
                  options={years}
                />
              </div>
              <div className="config">
                <SelectField
                  defaultValue={
                    eQuarter
                      ? { label: eQuarter?.toUpperCase(), value: eQuarter }
                      : undefined
                  }
                  onChange={(selected: { value: "q1" | "q2" | "q3" | "q4" }) =>
                    setEQuarter(selected?.value)
                  }
                  placeholder={t("quarter")}
                  options={[
                    { label: "Q1", value: "q1" },
                    { label: "Q2", value: "q2" },
                    { label: "Q3", value: "q3" },
                    { label: "Q4", value: "q4" },
                  ]}
                />
              </div>
            </>
          )}
          <br />

          <div className="text-center">
            <button
              type="button"
              className="button bg-gold color-white"
              style={{ padding: "15px 20px", cursor: loading ? "not-allowed" : "pointer" }}
              onClick={downloadReport}
              disabled={loading}
            >
              {loading ? `جاري توليد التقرير... ${progress}%` : "View Report"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
